import Swiper, {
    Navigation,
    Pagination,
    Thumbs,
    Autoplay,
    Scrollbar,
} from 'swiper';

Swiper.use([Navigation, Pagination, Thumbs, Autoplay, Scrollbar]);

export default class Slider {
    swiper$;

    get swiper() {
        return this.swiper$;
    }

    set swiper(value) {
        this.swiper$ = value;
    }

    constructor(element, options) {
        const {on: swiperEvents, ...others} = options;
        const sliderOptions = {
            ...{
                slidesPerView: 1,
                watchSlidesVisibility: true,
                spaceBetween: 32,
                speed: 500,
                loop: false,
                a11y: {
                    prevSlideMessage: 'Zurück',
                    nextSlideMessage: 'Nächste',
                },
                on: {
                    init: (swiper) => Slider.attachFocusHandler(swiper),
                    slideChange: (swiper) => {
                        if (swiper.realIndex === 0) {
                            Slider.shake(swiper.navigation.prevEl);
                        }
                    },
                    reachEnd: (swiper) => {
                        Slider.shake(swiper.navigation.nextEl);
                    },
                    ...swiperEvents,
                },
            },
            ...others,
        };

        this.swiper = new Swiper(element, sliderOptions);
    }

    static shake(node) {
        if (!node) {
            return;
        }

        node.classList.add('shake');
        setTimeout(() => {
            node.classList.remove('shake');
        }, 1000);
    }

    static attachFocusHandler(swiper) {
        const {slides} = swiper;

        slides.forEach((slide, index) => {
            slide.addEventListener('focusin', () => {
                if (swiper.realIndex !== index) {
                    swiper.slideTo(index);
                }
            });
        });
    }
}
